import { loadKpiData } from '../reducers/kpiDataReducer';

// Convert array to CSV string, or null if empty
const toCSV = (v) => {
	if (!v) return null;
	const arr = Array.isArray(v) ? v : [v];
	return arr.length > 0 ? arr.join(',') : null;
};

export const applyAndFetchKpiData = () => (dispatch, getState) => {
	const { filters, activity } = getState();
	const activityId = activity.selected?.activityId;
	if (!activityId) return;

	const base = {
		activityId,
		aggLevel: filters.aggLevel,
		dateFrom: filters.dateFrom,
		dateTo:   filters.dateTo,
		operator: toCSV(filters.operator),
		vendor:   toCSV(filters.vendor),
		layer:    toCSV(filters.layer),
		siteId:   toCSV(filters.siteId),
		server:   toCSV(filters.server),
		tac:      toCSV(filters.tac),
	};

	const techs  = [filters.tech1, filters.tech2].filter(Boolean);
	const n      = filters.numCharts ?? 3;
	const charts = techs.flatMap(tech =>
		(filters.kpiSel[tech] ?? []).slice(0, n).map(kpiName => ({ ...base, tech, kpiName }))
	);

	if (charts.length) dispatch(loadKpiData(charts));
};

export const fetchTech2Data = (tech2) => (dispatch, getState) => {
	const { filters, activity } = getState();
	const activityId = activity.selected?.activityId;
	if (!activityId || !tech2) return;

	const base = {
		activityId,
		aggLevel: filters.aggLevel,
		dateFrom: filters.dateFrom,
		dateTo:   filters.dateTo,
		operator: toCSV(filters.operator),
		vendor:   toCSV(filters.vendor),
		layer:    toCSV(filters.layer),
		siteId:   toCSV(filters.siteId),
		server:   toCSV(filters.server),
		tac:      toCSV(filters.tac),
	};

	const n      = filters.numCharts ?? 3;
	const charts = (filters.kpiSel[tech2] ?? []).slice(0, n).map(kpiName => ({
		...base, tech: tech2, kpiName,
	}));

	if (charts.length) dispatch(loadKpiData(charts));
};